import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 04020C45-A5ED-4D33-A7BD-AE986516C0DE
 * name code-array
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/code-array.svg
 * tags
 * - Developer / Languages 
 */
export const CodeArrayIcon = createSvgIcon(<><path d="M3,5A2,2 0 0,1 5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5M6,6V18H10V16H8V8H10V6H6M16,16H14V18H18V6H14V8H16V16Z" /></>, 'CodeArrayIcon');
export default CodeArrayIcon